import { Component } from '@angular/core';

import { TwistLogoComponent } from '@twist/ui/components';

@Component({
  standalone: true,
  imports: [TwistLogoComponent],
  templateUrl: './no-access-page.component.html',
  styleUrl: './no-access-page.component.scss',
})
export class NoAccessPageComponent {}
